import type { portalConfigurationApi } from 'app/src/services/welfareportal'

export const mockPortalConfig: portalConfigurationApi.PortalConfig = {
  preloginApplicationUri: 'http://localhost:3000',
  iconPdfSrc: 'pi pi-paperclip',
  paginatorConfig: {
    initialPageSize: 20,
    loadMorePageSize: 10,
    renderedInitialPageSize: 20,
    renderedLoadMorePageSize: 10,
  },
  joinConfig: {
    joinPercentages: [0.1, 0.2, 0.25, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
  },
  showCaseConfig: {
    productCardTreshold: 4,
    maxVoucherCount: 10,
    maxVoucherTypeCount: 5,
    mapsConfig: {
      displayCircle: true,
      enableMap: true,
      maxLocationRadius: 60000,
      atlasInitialFreeLocationRadius: 30000,
      initialCords: {
        lat: 41.89193,
        lon: 12.51133,
      },
      useNavigatorPosition: true,
      atlasAddress: 'https://atlas.microsoft.com',
      mapCountry: 'IT',
      atlasAuthenticationMode: 'subscriptionKey',
      atlasAuthenticationSubscriptionKey: 'DfqP6FI_8zZSNBcVG7x7Ed6l0zFyJ84GrdiNk9-vFZM',
      atlasApiVersion: '1.0',
      atlasInitialAddressZoom: 10,
      atlasInitialFreeZoom: 10,
      atlasMaxZoomCircle: 7.8,
      enforceProductBoundingBoxCheck: false,
    },
  },
  membershipConfig: {
    privacyFileMaxUploadSize: 10000000,
    privacyFileAcceptMimeTypes: ['application/pdf', 'image/png', 'image/jpeg'],
    privacyFileAcceptTypes: ['.pdf', '.jpg', '.png'],
  },
  shoppingConfig: {
    cardPolling: {
      cardPollingInterval: 2000,
      cardTakeInChargeMaxCount: 5,
    },
    documentAi: {
      documentAiMaxCount: 10,
      documentAiPollingInterval: 1000,
      fileAcceptMimeTypes: ['application/pdf', 'image/png', 'image/jpeg'],
      fileAcceptTypes: ['.pdf', '.png', '.jpg'],
      maxUploadFileSize: 5000000,
    },
  },
}
